import { MapFieldSetting } from 'map-settings'
import { SideBar as View } from 'ui-components'
import { MapSettings } from '~map-preview/App/Layout/SideBar/Adapters/MapSettings'
import { MapFeatureInfo } from '~map-preview/App/Tools/MapFeatureInfo'
import { MapFeatureInfoHeader } from '~map-preview/App/Tools/MapFeatureInfo/MapFeatureInfoHeader'
import { MapFilterDrawer } from '~map-preview/App/Tools/MapFilterDrawer'
import { MapFilterHeader } from '~map-preview/App/Tools/MapFilterDrawer/header'
import { MapInfo } from '~map-preview/App/Tools/MapInfo'
import { MapInfoHeader } from '~map-preview/App/Tools/MapInfo/MapInfoHeader'
import { MapLegendDrawer } from '~map-preview/App/Tools/MapLegendDrawer'
import { MapLegendHeader } from '~map-preview/App/Tools/MapLegendDrawer/MapLegendHeader'
import { MapRemixDrawer } from '~map-preview/App/Tools/MapRemixDrawer'
import { MapRemixHeader } from '~map-preview/App/Tools/MapRemixDrawer/MapRemixHeader'
import { MapSaveDrawer } from '~map-preview/App/Tools/MapSaveDrawer'
import { MapSearchHeader } from '~map-preview/App/Tools/MapSearch/MapSearchHeader'
import { MapShareDrawer } from '~map-preview/App/Tools/MapShareDrawer'
import { Infographic } from '~map-preview/App/Tools/Infographic'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { Embed } from '~map-preview/App/Tools/Embed'

export const SideBarComponents = {
  filter: {
    title: <MapFilterHeader />,
    content: <MapFilterDrawer />
  },
  search: {
    title: <MapSearchHeader />,
    content: <MapFeatureInfo />
  },
  share: {
    title: <div>Share map</div>,
    content: <MapShareDrawer />
  },
  settings: {
    title: <div>Settings</div>,
    content: <MapSettings />
  },
  fieldSettings: {
    title: <div>Field settings</div>,
    content: <MapFieldSetting />
  },
  info: {
    title: <MapInfoHeader />,
    content: <MapInfo />
  },
  mapFeatureInfo: {
    title: <MapFeatureInfoHeader />,
    content: <MapFeatureInfo />
  },
  remix: {
    title: <MapRemixHeader />,
    content: <MapRemixDrawer />
  },
  legend: {
    title: <MapLegendHeader />,
    content: <MapLegendDrawer />
  },
  mapSave: {
    title: <div>Save map</div>,
    content: <MapSaveDrawer />
  },
  infographic: {
    title: <div>Infographic</div>,
    content: <Infographic />
  },
  embed: {
    title: <div>Embed</div>,
    content: <Embed />
  }
}

const Content = () => {
  const { sideBar } = useMapNavStore()
  const content = (sideBar && SideBarComponents[sideBar]?.content) || null
  return content
}

const Title = () => {
  const { sideBar } = useMapNavStore()
  return (sideBar && SideBarComponents[sideBar]?.title) || ''
}

export const SideBar = () => {
  const { drawerOpen, setOpenDrawer, sideBar, setSideBar, setOpenTable } =
    useMapNavStore()

  const handleDrawerClose = () => {
    const nextSideBar = sideBar && sideBarTransitions[sideBar]?.next
    if (nextSideBar) {
      setSideBar(nextSideBar)
      return
    }

    setOpenDrawer(false)
    setOpenTable(false)

    const sideBarsToReset = ['embed', 'filter', 'share', 'info', 'settings']
    if (sideBar && sideBarsToReset.includes(sideBar)) {
      setSideBar('map')
      return
    }

    setSideBar('')
  }

  return (
    <View
      slots={{
        Title: <Title />,
        Content: <Content />
      }}
      open={drawerOpen}
      onOpenChange={handleDrawerClose}
    />
  )
}

const sideBarTransitions = {
  fieldSettings: { next: 'settings' },
  remix: { next: 'share' },
  infographic: { next: 'share' },
  embed: { next: 'share' }
}
